import { render, staticRenderFns } from "./IconRefrigeratedTruck.vue?vue&type=template&id=f9e15f5c"
import script from "./IconRefrigeratedTruck.vue?vue&type=script&lang=js"
export * from "./IconRefrigeratedTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports